import React, { useState } from 'react';
import { UiKit } from '@datavant/uikit';

export const getRingCentralChat = (): any => {
    return (window as any)['icPatronChat'];
};

const Button = (): JSX.Element => {
    const [isLiveChatOpen, setIsLiveChatOpen] = useState(false);

    return (
        <div
            style={{
                position: 'fixed',
                bottom: 40,
                left: 10,
                zIndex: 90000,
                display: 'block',
            }}
        >
            <UiKit.Button.TopBar
                text={isLiveChatOpen ? 'Close Chat' : 'Live Chat'}
                onClick={() => {
                    if (isLiveChatOpen) {
                        getRingCentralChat().hide();
                    } else {
                        getRingCentralChat().show();
                    }
                    setIsLiveChatOpen(!isLiveChatOpen);
                }}
            />
        </div>
    );
};

const Link = (props: { text: string }): JSX.Element => {
    return (
        <UiKit.Text.Clickable
            onClick={() => getRingCentralChat().show()}
            text={props.text}
            color={UiKit.consistency.primaryBlue40}
        />
    );
};

export const RingCentral = {
    ScriptURL: 'https://home-c52.nice-incontact.com/inContact/ChatClient/js/embed.min.js',
    Button: Button,
    Link: Link,
    init: (): void => {
        getRingCentralChat().init({
            serverHost: 'https://home-c52.nice-incontact.com',
            bus_no: 4603168,
            poc: '7a37c9e1-94de-4939-8726-27ee3fd07d59',
            params: ['FirstName', 'Last Name', 'first.last@company.com', 555 - 555 - 5555],
            customChatButton: true,
        });
        getRingCentralChat().setDimension({
            top: 55,
            left: 10,
            height: 800,
            width: 600,
        });
    },
};
